import { t } from 'i18next'
import React from 'react'
import classNames from 'classnames'

import { LegalLinks } from './utils'

interface PublicFooterProps {
  legalLinks: LegalLinks
}

export const PublicFooter: React.FC<PublicFooterProps> = ({ legalLinks }) => {
  const hasAtLeastOneLegalLink = Object.values(legalLinks).some(
    (link) => !!link
  )
  return (
    <div
      className={classNames(
        'max-w-5xl grid min-tablet:grid-cols-3 gap-y-10 min-tablet:gap-x-16 py-12 px-6 min-tablet:px-16 text-sm min-tablet:text-lg text-white',
        {
          'min-tablet:mx-auto': hasAtLeastOneLegalLink,
        }
      )}
    >
      <div className="flex justify-center md:justify-start mb-10 min-tablet:col-span-3">
        <div className="flex items-center">
          <img
            src="/images/footer-logo.svg"
            alt="logo"
            className="mr-4 w-full max-w-[180px] max-h-14"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 min-tablet:block">
        <div className="space-y-6 underline text-common-blue-3 text-base">
          <div>
            {legalLinks.privacyStatement && (
              <p>
                <a
                  target="_blank"
                  className="underline"
                  href={legalLinks.privacyStatement}
                  rel="noreferrer"
                >
                  {t('contact:legal.privacyStatementLinkText')}
                </a>
              </p>
            )}
            {legalLinks.accessibilityStatement && (
              <p>
                <a
                  target="_blank"
                  className="underline"
                  href={legalLinks.accessibilityStatement}
                  rel="noreferrer"
                >
                  {t('contact:legal.accessibilityStatementLinkText')}
                </a>
              </p>
            )}
            {legalLinks.termsOfUse && (
              <p>
                <a
                  target="_blank"
                  className="underline"
                  href={legalLinks.termsOfUse}
                  rel="noreferrer"
                >
                  {t('contact:legal.termsOfUseLinkText')}
                </a>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
